import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],
})

export class AdminDashboardComponent implements OnInit {
  activePage: string = 'dump';
  @ViewChild('downloadModal') downloadModal!: TemplateRef<any>;
  users: any[] = [];
  newUser: any = { username: '', loginId: '', password: '', userType: '', userBatch: '' };
  batches: any[] = []; // Can be fetched from backend later
  username: string = '';
  constructor(private adminService: AdminService, private authService: AuthService, private toaster: ToastrService, private modalService: NgbModal) { }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.username = user.username;
    this.loadBatches();
    this.loadUsers();
    this.getDumpList();
  }

  onLogout() {
    this.authService.logout();
  }
  loadUsers() {
    console.log("In load users in comp")
    this.adminService.getUsers().subscribe((userdata) => this.users = userdata.Data);
  }
  loadBatches() {
    this.adminService.getBatches().subscribe((batchdata) => this.batches = batchdata.Data);
  }


  addUser() {
    this.adminService.addUser(this.newUser).subscribe(() => {
      this.loadUsers();
      this.newUser = { userId: 0, username: '', loginId: '', password: '', userType: '', userBatch: '' };
    });
  }

  updateUser(user: any) {
    this.adminService.updateUser({ userId: user.userId, userStatus: user.userStatus, userBatch: user.userBatch })
      .subscribe(() => this.loadUsers());
  }

  resetPassword(user: any) {
    if (!confirm(`Reset password for ${user.username}? New password will be same as username.`)) return;

    this.adminService.resetPassword(user.userId).subscribe({
      next: (res) => this.toaster.success(res.errorDescription || 'Password reset successfully', 'Success'),
      error: (err) => this.toaster.error('Error resetting password: ' + err.message, 'Error')
    });
  }


  selectedDumpType: string = '';
  selectedExistingDump: string = '';
  availableDumps: { key: string, value: string }[] = [];
  isGenerating: boolean = false;
  isDownloading: boolean = false;

  generateDump() {
    if (!this.selectedDumpType) return;
    this.isGenerating = true;
    this.adminService.getDBDump(this.selectedDumpType).subscribe({
      next: (res) => {
        this.toaster.success(res.errorDescription || 'Dump generated successfully', 'Success');
        this.getDumpList();
        this.isGenerating = false;
        this.selectedDumpType = '';
      },
      error: (err) => {
        this.toaster.error('Error generating dump: ' + err.message, 'Error');
        this.isGenerating = false;
      }
    });
  }

  getDumpList() {
    this.adminService.getDumpList().subscribe((batchdata) => this.availableDumps = batchdata.Data);
  }

  // downloadExistingDump() {
  //   if (!this.selectedExistingDump) return;
  //   this.isDownloading = true;
  //   this.adminService.downloadDump(this.selectedExistingDump).subscribe({
  //     next: (blob) => {
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       // a.download = this.selectedExistingDump.split('/').pop() || 'dump.zip';
  //       a.download = this.selectedExistingDump.split('/').pop()?.replace('.zip', '.sql') || 'dump.sql';
  //       a.click();
  //       window.URL.revokeObjectURL(url);
  //       this.isDownloading = false;
  //       this.selectedExistingDump = '';
  //     },
  //     error: (err) => {
  //       this.toaster.error('Error downloading dump: ' + err.message, 'Error');
  //       this.isDownloading = false;
  //     }
  //   });
  // }


  downloadExistingDump() {
    if (!this.selectedExistingDump) return;
    this.isDownloading = true;
    this.adminService.downloadDump(this.selectedExistingDump).subscribe({
      next: (blob: Blob) => {
        const selectedDumpObj = this.availableDumps.find(
          dump => dump.value === this.selectedExistingDump
        );

        const fileName = `Dump_${selectedDumpObj?.key}.zip`;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(url);
        this.isDownloading = false;
        this.selectedExistingDump = '';
      },
      error: (err) => {
        this.toaster.error('Error downloading dump: ' + err.message, 'Error');
        this.isDownloading = false;
      }
    });
  }


}
